<link rel="stylesheet" href="https://unpkg.com/@progress/kendo-font-icons/dist/index.css" />

<kendo-dialog-titlebar>
  <div style="font-size: 18px; line-height: 1.3em;">
    <span class="k-icon k-font-icon k-icon-xl k-i-trash"></span> {{title}}
  </div>
</kendo-dialog-titlebar>

<div class="container">
  <div class="error-align">
    <h4><strong><span [innerHTML]="content"></span></strong></h4>
  </div>
</div>

<kendo-dialog-actions>
  <button kendoButton themeColor="error" (click)="confirmClose()">
    Delete </button>
  <button kendoButton themeColor="light" (click)="errorClose()">
    Cancel </button>
</kendo-dialog-actions>
